<!-- order-flow-order-summary.component.html -->

<div class="order-summary">
  <!-- Order Details Section -->
  <div class="summary-section">
    <div class="summary-block">
      <h2 style="font-weight: 600; text-align: center; margin-bottom: 3%">
        Order Summary
      </h2>
      <div style="background-color: #f5f5f5; padding: 2%">
        <!-- Loop over grouped order details -->
        <div
          *ngFor="let group of groupedOrderDetails"
          style="
            margin-bottom: 2%;
            background-color: white;
            padding: 5%;
            padding-top: 2%;
          "
        >
          <h3 style="font-weight: 600">{{ group.groupName }}</h3>

          <div
            class="measurement-grid"
            style="
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              grid-gap: 20px;
              text-align: left;
            "
          >
            <div *ngFor="let item of group.items" style="display: flex; flex-direction: column; text-align: left;">
              <span style="font-weight: 600">{{ item.label }}</span>
              <span style="word-break: break-word; max-width: 250px;">
                {{ item.value || "N/A" }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Measurements Section -->
  <div class="summary-section" style="background-color: white">
    <div class="summary-block" style="background-color: white">
      <h2 style="font-weight: 600; text-align: center; margin-bottom: 5%">
        Measurements
      </h2>
      <div>
        <!-- Loop over grouped measurements -->
        <div
          *ngFor="let measurementGroup of groupedMeasurements"
          style="background-color: #f5f5f5; margin-bottom: 5%; padding: 5%"
        >
          <!-- Display the Left Foot and Right Foot sections dynamically -->
          <div class="foot-section">
            <h4 style="font-weight: 600">
              {{ measurementGroup.attributeOptionName }}
            </h4>

            <div
              class="foot-content"
              style="display: flex; align-items: flex-start"
            >
              <!-- Display the foot diagram image -->
              <div class="foot-image" style="padding-top: 3%; width: 20%">
                <img
                  [src]="measurementGroup.imageUrl"
                  alt="{{ measurementGroup.attributeOptionName }}"
                  style="max-width: 100%; height: auto"
                />
              </div>

              <!-- Display the measurements in a 4-column grid -->
              <div
                class="foot-measurements"
                style="
                  margin-left: 20px;
                  width: 70%;
                  font-size: larger;
                  padding-left: 15%;
                  margin-top: 2%;
                "
              >
                <div
                  class="measurement-grid"
                  style="
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    grid-gap: 10px;
                    text-align: left;
                  "
                >
                  <div
                    *ngFor="let measure of measurementGroup.measures"
                    class="measurement-item"
                    style="display: flex; justify-content: start"
                  >
                    <span style="font-weight: 600; width: 70px">{{
                      measure.name
                    }}</span>
                    <span>{{ measure.value || "N/A" }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- end of foot-content -->
          </div>
          <!-- end of foot-section -->
        </div>
        <!-- end of ngFor loop over groupedMeasurements -->
      </div>
    </div>
  </div>

  <!-- Accessories Section -->
  <div class="summary-block" style="background-color: white">
    <h2 style="font-weight: 600; text-align: center; margin-bottom: 5%">
      Accessories
    </h2>

    <div *ngIf="groupedAccessories.length > 0; else noAccessories">
      <div
        *ngFor="let accessory of groupedAccessories"
        class="accessory-group"
        style="background-color: #f5f5f5; margin-bottom: 5%; padding: 5%"
      >
        <h3 style="font-weight: 600">
          {{ accessory.accessory.accessoryName }}
        </h3>

        <div
          class="foot-content"
          style="display: flex; align-items: flex-start"
        >
          <div
            *ngIf="accessory.selectedImage"
            class="foot-image"
            style="padding-top: 3%; width: 40%"
          >
            <img
              [src]="
                'data:image/svg+xml;base64,' + accessory.selectedImage.imageUrl
              "
              style="max-width: 100%; height: auto"
            />
          </div>

          <div
            class="foot-measurements"
            style="
              margin-left: 20px;
              flex: 1;
              margin-top: 2%;
              font-size: larger;
            "
          >
            <div
              class="measurement-grid"
              style="
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                grid-gap: 10px;
              "
            >
              <div
                *ngFor="let attribute of accessory.selectedAttributes"
                class="measurement-item"
                style="display: flex; flex-direction: column"
              >
                <span style="font-weight: 600">{{
                  attribute.name
                }}</span>
                <span>{{ attribute.value || "N/A" }}</span>
              </div>

              <div
                *ngIf="accessory.textAttributes.length > 0"
                class="text-attributes-section"
              >
                <div *ngFor="let textAttr of accessory.textAttributes">
                  <span style="font-weight: 600; margin-right: 5%">{{
                    textAttr.name
                  }}</span>
                  <span>{{ textAttr.value || "N/A" }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of accessory-group -->
    </div>
    <!-- End of ngFor loop over accessories -->

    <ng-template #noAccessories>
      <p>No accessories selected.</p>
    </ng-template>
  </div>

  <!-- Attachments Section -->
  <div class="p-4" style="margin-bottom: 40px; background-color: white; width: 100%;">
    <h1 class="text-center">Attachments</h1>
    <h2 class="text-center" style="font-size: 0.95rem; font-weight: normal;">
      A maximum of 5 files may be uploaded, with a total combined size of up to 10 MB.
    </h2>
  
    <div id="drop-zone"
         class="drop-zone text-center p-5"
         (drop)="onDrop($event)"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         style="border: 2px dashed #ccc; border-radius: 10px; cursor: pointer; position: relative;">
         
      <input 
         id="file"
         type="file"
         class="form-control"
         multiple
         (change)="onFileChange($event)"
         style="opacity: 0; position: absolute; top:0; left:0; right:0; bottom:0; cursor: pointer;"
      >
      
    <p>Drop your files here or click to select</p>
    </div>
    <div *ngIf="attachments && attachments.length > 0" class="mt-4">
      <ul style="display: block; list-style: none; padding: 0;">
        <li *ngFor="let attachment of attachments; let i = index" 
            style="display: flex; justify-content: space-between; align-items: center; padding: 8px; margin-bottom: 5px; background-color: #f8f9fa; border-radius: 5px; border: 1px solid #dee2e6;">
          <span style="flex-grow: 1; margin-right: 10px;">{{ attachment.fileName }}</span>
          <button 
            type="button" 
            (click)="removeAttachment(i)"
            style="background-color: #dc3545; color: white; border: none; border-radius: 3px; padding: 4px 8px; cursor: pointer; font-size: 0.8rem;"
            title="Remove file">
            ✕
          </button>
        </li>
      </ul>
    </div>

    <div *ngIf="tooManyFiles" class="alert alert-warning mt-3">
      You have attempted to upload more than 5 files. Only the first 5 have been processed.
    </div>
  </div>

  <!-- Comments Section -->
  <div class="summary-block" style="background-color: white; padding: 20px;">
    <h1 class="text-center">Comments</h1>
    <div class="comments-section">
      <textarea
        [(ngModel)]="comments"
        rows="5"
        placeholder="Add your comments here..."
        style="width: 100%; padding: 10px; border-radius: 6px; border: 1px solid #ccc; font-size: 1rem; resize: vertical;"
      ></textarea>
    </div>
  </div>
</div>
